import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

// Define the base URL once for consistency
const BASE_URL = 'https://www.stvmhss.in';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonicalPath 
}) => {
  const location = useLocation();
  // Construct the full canonical URL using the provided path or the current route
  const fullCanonicalUrl = `${BASE_URL}${canonicalPath || location.pathname}`;

  // Default meta values from index.html (to be overwritten by page props)
  const defaultTitle = "St. Thomas Vidyalayam Matric Higher Secondary School - STVMHSS | Chennai";
  const defaultDescription = "Official site of St. Thomas Vidyalayam Matric Higher Secondary School, Chennai. Modern campus, excellent faculty, vibrant student life, and proven academic results. Admissions open now!";
  
  // Set the correct title (combining page title and site name)
  const finalTitle = title ? `${title} | STVMHSS Chennai` : defaultTitle;

  return (
    <Helmet>
      {/* Dynamic Title */}
      <title>{finalTitle}</title>
      
      {/* Dynamic Meta Description */}
      <meta name="description" content={description || defaultDescription} />
      
      {/* Dynamic Keywords */}
      {keywords && <meta name="keywords" content={keywords} />}

      {/* CRITICAL FIX: Dynamic Canonical Tag */}
      <link rel="canonical" href={fullCanonicalUrl} />

      {/* Dynamic Open Graph/Twitter Tags */}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:url" content={fullCanonicalUrl} />
      {/* Note: Other og: tags like og:image should also be updated here if needed */}
    </Helmet>
  );
};

export default SEO;